import React from "react";
import speakerIconBrown from "assets/images/icons/speaker-icon-brown.svg";
import { CircleTipProgressBar } from "shared";
import { formatDuration } from "utils";

export const ProgramDetailsCard = ({
  title,
  theme,
  progress = null,
  totalAssignmentHour = null,
  completedAssignmentHour = null,
  totalCount = null,
  scheduledAssessmentCount = null,
  isAssessment = false,
  displayDuration = false,
  icon,
  onClick,
  assignmentProgress = null,
  isFullWidthIcon = false,
}) => {
  const progressBar = assignmentProgress;

  const handleDuration = () => {
    if (displayDuration) {
      return (
        formatDuration(completedAssignmentHour) +
        "/" +
        formatDuration(totalAssignmentHour)
      );
    } else {
      return null;
    }
  };

  return (
    <div
      className="featured-item d-flex flex-column cursor-pointer"
      onClick={onClick}
    >
      <div className="featured-content">
        <div
          className={`item-thumbnail ${
            isFullWidthIcon ? "full-width-thumbnail" : ""
          }`}
          style={{ backgroundColor: theme }}
        >
          <img className="img-fluid" src={icon} alt="" />
        </div>
        {isAssessment && !!totalCount && (
          <div className="grid-badge">
            <img src={speakerIconBrown} alt="" />
            <span>
              {scheduledAssessmentCount + "/" + totalCount} Assessment scheduled
            </span>
          </div>
        )}
      </div>
      <div className="grid-item-content px-2">
        <h2 className="text-wrap mb-2 fw-semibold ellipsis-text">{title}</h2>
        {progress !== null && (
          <CircleTipProgressBar width={progress} label={progress + "%"} />
        )}
        {(totalAssignmentHour !== null || completedAssignmentHour !== null) &&
        !!assignmentProgress ? (
          <CircleTipProgressBar
            width={!!progressBar ? progressBar : 0}
            label={displayDuration ? handleDuration() : progressBar + "%"}
          />
        ) : (
          displayDuration && (
            <span className="display-duration">{handleDuration()}</span>
          )
        )}
      </div>
    </div>
  );
};
